const { toString, toStringArray } = require('@/functions/transform');

/**
 * Normalizes a barcode into the form it is stored and looked up in (uppercase).
 *
 * @param {string} barcode
 *
 * @return {string}
 */
const normalizeBarcode = (barcode) => toString(barcode).toUpperCase();

/**
 * @param {[]} value
 *
 * @return {string[]}
 */
const toBarcodeArray = (value) => toStringArray(value).map(normalizeBarcode);

module.exports = {
    normalizeBarcode,
    toBarcodeArray,
};
